// extracted by mini-css-extract-plugin
export default {"about":"About_about__8nvF7","section1":"About_section1__NNEoM","section2":"About_section2__U4N-2","wrapper":"About_wrapper__XhjWE","mapContainer":"About_mapContainer__opKIR"};